<script lang="ts">
	import type { UserData } from '@/global.d.ts';

	import * as Auth from '@/lib/authentication.ts';
	import { Logger } from '@/lib/log.ts';

	import '../DstPushNotifications/DstPushNotifications.webcomponent.svelte';

	import * as userStore from '@/stores/userState.ts';
	import { onMount } from 'svelte';

	export let appid;
	export let variant;
	export let hint;

	let enablePushNotifications = false;
	let communityMemberSub;
	const log = Logger('header.PushNotifications');

	onMount(async () => {
		log.debug('onMount');
		let userState: UserData;
		const session = await Auth.getSession();

		window.CleverPush = window.CleverPush || [];

		if (session) {
			userState = await userStore.get();
			userStore.set(userState);
			communityMemberSub = session?.idToken?.payload?.sub;
		} else {
			log.debug('No user logged in. Setting default user state.');
			userState = {
				isLoggedIn: false,
				isPurUser: false,
			};
		}
		enablePushNotifications =
			appid === 'editorialweb' && variant === 'at' && !userState?.isPurUser && hint !== 'minimal';

		if (communityMemberSub && enablePushNotifications && window.CleverPush) {
			window.CleverPush.push(['setAttribute', 'user_id', communityMemberSub]);
			log.debug(`CleverPush attribute set with user_id: ${communityMemberSub}`);
		}
	});
</script>

<!--
	During development the CleverPush modal is often in the way. It can be disabled by setting the `VITE_CLEVERPUSH_ENABLE`#
	environment variable. We should probably find a more general solution for this that also works for our users.
-->
{#if enablePushNotifications && import.meta.env.VITE_CLEVERPUSH_ENABLE === 'true'}
	<dst-push-notifications />
{/if}
